'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getMuiTheme = require('material-ui/styles/getMuiTheme');

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _MuiThemeProvider = require('material-ui/styles/MuiThemeProvider');

var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRedux = require('react-redux');

var _reduxPersist = require('redux-persist');

var _storage = require('redux-persist/es/storage');

var _storage2 = _interopRequireDefault(_storage);

var _react3 = require('redux-persist/es/integration/react');

var _reactRouterRedux = require('../components/react-router-redux');

var _reducers = require('../reducers');

var _reducers2 = _interopRequireDefault(_reducers);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

var _content = require('./content');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var muiTheme = (0, _getMuiTheme2['default'])(_theme2['default']);

var persistConfig = {
  key: 'root',
  storage: _storage2['default']
};

var store = (0, _redux.createStore)((0, _reduxPersist.persistCombineReducers)(persistConfig, (0, _extends3['default'])({}, _reducers2['default'], {
  router: _reactRouterRedux.routerReducer
})), (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2['default']), (0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)()), window.devToolsExtension ? window.devToolsExtension() : function (f) {
  return f;
}));

var persistor = (0, _reduxPersist.persistStore)(store);

exports['default'] = _react2['default'].createClass({

  displayName: "Application",

  render: function render() {

    return _react2['default'].createElement(
      _react3.PersistGate,
      { persistor: persistor },
      _react2['default'].createElement(
        _reactRedux.Provider,
        { store: store },
        _react2['default'].createElement(
          _MuiThemeProvider2['default'],
          { muiTheme: muiTheme },
          _react2['default'].createElement(
            _reactRouterRedux.ConnectedRouter,
            null,
            _react2['default'].createElement(_content.RootContent, null)
          )
        )
      )
    );
  }
});


//////////////////
// WEBPACK FOOTER
// ./program/frontend/application/index.jsx
// module id = 581
// module chunks = 0